import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
var CenterTop = /*#__PURE__*/function (_Vue) {
  function CenterTop() {
    var _this;
    _classCallCheck(this, CenterTop);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CenterTop, [].concat(args));
    _defineProperty(_this, "logo", void 0);
    return _this;
  }
  _inherits(CenterTop, _Vue);
  return _createClass(CenterTop, [{
    key: "backgroundStyle",
    get: function get() {
      if (this.logo !== undefined) {
        return "background-image:url(".concat(this.logo, ")");
      }
      return '';
    }
  }]);
}(Vue);
export { CenterTop as default };
__decorate([Prop()], CenterTop.prototype, "logo", void 0);